export enum State {
    LOGGED = 'LOGGED',
    HELD = 'HELD',
    DELEGATED = 'DELEGATED',
    NORMAL = 'NORMAL',
    SUGGESTED = 'SUGGESTED',
    VIM_ELIGIBLE = 'VIM_ELIGIBLE',
}
